import { createContext, useContext } from 'react';
import { WidgetContext } from 'core/dashboard/types/widgetStateTypes';

export const widgetContext = createContext<WidgetContext>(null as any);

export function useWidgetContext() {
    return useContext(widgetContext);
}
